import { Drawer } from "@renderbus/ui";
import styled from "styled-components";

export const StudentDrawer = styled(Drawer)`
  .student-drawer {
    .ant-drawer-header,
    .ant-drawer-body {
      background-color: #262729 !important;
    }
  }
`;
